import React, {useCallback} from "react";
import DateTH from "../../../../Helper/date-th";

const ShowData = React.memo(({data,validateDimension}) => {

    const getInfoDisplay = useCallback(
        (old_value,new_value) => {
            return (
                old_value === new_value ? <>{old_value}</> : (
                    <div className="d-flex flex-space-between w-100">
                        <div className="d-flex flex-column" style={{gap: '5px'}}>
                            <p style={{marginBottom: 0}}>{old_value ?? ''}</p>
                            <p style={{marginBottom: 0}}>(เก่า)</p>
                        </div>
                        <p>{"->"}</p>
                        <div className="d-flex flex-column" style={{gap: '5px'}}>
                            <p style={{marginBottom: 0}}>{new_value ?? ''}</p>
                            <p style={{marginBottom: 0}}>(ใหม่)</p>
                        </div>
                    </div>
                )
            );
        },
        [],
    );

    return (
        <table className="table table-bordered">
            <thead style={{ backgroundColor: '#3f75c1' }}>
            <tr style={{ color: '#FFFFFF' }}>
                <td style={{ width: '7%' }}>บาร์โค้ด</td>
                <td style={{ width: '7%' }}>วันที่แก้ไข</td>
                <td style={{ width: '7%' }}>ผู้แก้ไขข้อมูล</td>
                <td style={{ width: '7%' }}>รหัสลูกค้า</td>
                <td style={{width: '7%'}}>น้ำหนัก</td>
                <td style={{width: '7%'}}>ความยาว</td>
                <td style={{width: '7%'}}>ความสูง</td>
                <td style={{width: '7%'}}>ความกว้าง</td>
                <td style={{width: '7%'}}></td>
                
            </tr>
            </thead>
            <tbody>
                {data.map(row => (
                    <tr>
                        <td>{row.awb_code}</td>
                        <td><DateTH date={row.scan_date}/></td>
                        <td>{row.staff_code}</td>
                        <td>{row.machine_code}</td>
                        <td>{row.weight}</td>
                        <td>{row.length}</td>
                        <td>{row.height}</td>
                        <td>{row.width}</td>
                        <td>
                            <div className="d-grid">
                                <span>
                                    <button className="btn btn btn-warning m-1" onClick={ async (e)=>{
                                        // await getDataExcel(search,localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code,startDate,endDate);
                        
                                        }}> edit </button>
                                </span>
                                <span>
                                    <button className="btn btn btn-success m-1" onClick={ async (e)=>{
                                        // await getDataExcel(search,localStorage.getItem("superkey")==="credit"?localStorage.getItem("username"):cust_code,startDate,endDate);
                                        validateDimension(row.id)
                                        }}> validate </button>
                                </span>
                            </div>
                        </td>

                    </tr>
                ))}
            </tbody>
        </table>
    );
})

export default ShowData;